import { apiCall, createQueryString } from "./../imports";
const PREFIX = "management/carriers";

export default {
  getCarriers(data) {
    return apiCall("get", `${PREFIX}${createQueryString(data)}`);
  },

  deleteCarriers(id) {
    return apiCall("delete", `${PREFIX}/${id}`);
  },

  addCarriers(data) {
    return apiCall("post", `${PREFIX}/panel/create`, data);
  },
};
